import { SimpleFlagProps } from 'src/redux/flags/types';
import { urls } from 'src/urls/workspaces';

import { messages } from './atlassian-intelligence.i18n';
import atlassianIntelligenceUrls from './urls';

export function getAiToggleAgenticPipelinesFlag({
  workspace,
  on,
  error,
}: {
  workspace: string;
  on: boolean;
  error: boolean;
}): Omit<SimpleFlagProps, 'handleDismissed'> {
  if (error) {
    return {
      iconType: 'error',
      id: 'atlassian-intelligence-toggle-error-agentic-pipelines-flag',
      title: {
        msg: messages.atlassianIntelligenceToggleAgenticPipelinesFlagError,
      },
      autoDismiss: true,
    };
  }
  if (on) {
    return {
      iconType: 'success',
      id: 'atlassian-intelligence-turn-on-agentic-pipelines-flag',
      title: {
        msg: messages.atlassianIntelligenceTurnOnAgenticPipelinesFlagTitle,
      },
      description: {
        msg: messages.atlassianIntelligenceTurnOnAgenticPipelinesFlagDescription,
        values: {
          workspace,
        },
      },
      autoDismiss: true,
    };
  } else {
    return {
      iconType: 'success',
      id: 'atlassian-intelligence-turn-off-agentic-pipelines-flag',
      title: {
        msg: messages.atlassianIntelligenceTurnOffAgenticPipelinesFlagTitle,
      },
      description: {
        msg: messages.atlassianIntelligenceTurnOffAgenticPipelinesFlagDescription,
        values: {
          workspace,
        },
      },
      autoDismiss: true,
    };
  }
}

export function getAiToggleRovoChatFlag({
  workspace,
  on,
  error,
}: {
  workspace: string;
  on: boolean;
  error: boolean;
}): Omit<SimpleFlagProps, 'handleDismissed'> {
  if (error) {
    return {
      iconType: 'error',
      id: 'atlassian-intelligence-toggle-error-rovo-chat-flag',
      title: {
        msg: messages.atlassianIntelligenceToggleRovoChatFlagError,
      },
      autoDismiss: true,
    };
  }
  if (on) {
    return {
      iconType: 'success',
      id: 'atlassian-intelligence-turn-on-rovo-chat-flag',
      title: {
        msg: messages.atlassianIntelligenceTurnOnRovoChatFlagTitle,
      },
      description: {
        msg: messages.atlassianIntelligenceTurnOnRovoChatFlagDescription,
        values: {
          workspace,
        },
      },
      autoDismiss: true,
    };
  } else {
    return {
      iconType: 'success',
      id: 'atlassian-intelligence-turn-off-rovo-chat-flag',
      title: {
        msg: messages.atlassianIntelligenceTurnOffRovoChatFlagTitle,
      },
      description: {
        msg: messages.atlassianIntelligenceTurnOffRovoChatFlagDescription,
        values: {
          workspace,
        },
      },
      autoDismiss: true,
    };
  }
}

export function getAiToggleWritingAssistantFlag({
  workspace,
  on,
  error,
}: {
  workspace: string;
  on: boolean;
  error: boolean;
}): Omit<SimpleFlagProps, 'handleDismissed'> {
  if (error) {
    return {
      iconType: 'error',
      id: 'atlassian-intelligence-toggle-error-writing-assistant-flag',
      title: {
        msg: messages.atlassianIntelligenceToggleWritingAssistantFlagError,
      },
      autoDismiss: true,
    };
  }

  if (on) {
    return {
      iconType: 'success',
      id: 'atlassian-intelligence-turn-on-writing-assistant-flag',
      title: {
        msg: messages.atlassianIntelligenceTurnOnWritingAssistantFlagTitle,
      },
      description: {
        msg: messages.atlassianIntelligenceTurnOnWritingAssistantFlagDescription,
        values: {
          workspace,
        },
      },
      autoDismiss: true,
    };
  } else {
    return {
      iconType: 'success',
      id: 'atlassian-intelligence-turn-off-writing-assistant-flag',
      title: {
        msg: messages.atlassianIntelligenceTurnOffWritingAssistantFlagTitle,
      },
      description: {
        msg: messages.atlassianIntelligenceTurnOffWritingAssistantFlagDescription,
        values: {
          workspace,
        },
      },
      autoDismiss: true,
    };
  }
}

export function getAiToggleFlag({
  on,
  error,
  workspace,
}: {
  on: boolean;
  error: boolean;
  workspace: string;
}): Omit<SimpleFlagProps, 'handleDismissed'> {
  if (error) {
    if (on) {
      return {
        id: 'atlassian-intelligence-turn-on-error-flag',
        title: { msg: messages.atlassianIntelligenceFailedToActivateFlagTitle },
        description: {
          msg: messages.atlassianIntelligenceFailedFlagDescription,
        },
        iconType: 'error',
        actions: [
          {
            content: {
              msg: messages.atlassianIntelligenceFailedFlagDescriptionLinkText,
            },
            href: urls.external.contactSupportLink,
          },
        ],
      };
    } else {
      return {
        iconType: 'error',
        id: 'atlassian-intelligence-turn-off-error-flag',
        title: {
          msg: messages.atlassianIntelligenceFailedToDeactivateFlagTitle,
        },
        description: {
          msg: messages.atlassianIntelligenceFailedFlagDescription,
        },
        actions: [
          {
            content: {
              msg: messages.atlassianIntelligenceFailedFlagDescriptionLinkText,
            },
            href: urls.external.contactSupportLink,
          },
        ],
      };
    }
  } else {
    if (on) {
      return {
        id: 'atlassian-intelligence-turn-on-flag',
        title: { msg: messages.atlassianIntelligenceActivatedFlagTitle },
        description: {
          msg: messages.atlassianIntelligenceActivatedFlagDescription,
        },
        iconType: 'success',
        actions: [
          {
            content: {
              msg: messages.atlassianIntelligenceActivatedFlagLearnMoreLinkText,
            },
            href: atlassianIntelligenceUrls.ui.learnMore(),
          },
          {
            content: {
              msg: messages.atlassianIntelligenceActivatedFlagActivateForOtherAppsLinkText,
            },
            href: atlassianIntelligenceUrls.ui.otherProducts(),
          },
        ],
      };
    } else {
      return {
        id: 'atlassian-intelligence-turn-off-flag',
        title: { msg: messages.atlassianIntelligenceDeactivatedFlagTitle },
        description: {
          msg: messages.atlassianIntelligenceDeactivatedFlagDescription,
          values: { workspaceSlug: workspace },
        },
        iconType: 'success',
      };
    }
  }
}
